module.exports = __webpack_public_path__ + "img/learning@4x.6d7f9de2.png";